import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardBody, Button, CustomInput, ButtonGroup } from 'reactstrap';
import { Separator } from '../../../../../components/common/CustomBootstrap';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
    putAPI_Update_Ingetration,
    gAPI_Ingetration,
    putAPI_Update_EngagementRules,
    postAPI_QuestionOption_AllList
} from '../../../../../constants/APIs';
import { RuleForm } from './RuleForm';
import { RuleList } from './RuleList';
import Validation from '../../../../../components/Validation';
export default function RuleSetting({ LoadIntegration, integrationId }) {
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [enabled, setEnabled] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const [isStatusUpdating, setIsStatusUpdating] = useState(false);
    const [inputData, setInputData] = useState([]);
    const [ruleDataList, setRuleDataList] = useState([]);
    const [questionOptionsList, setQuestionOptionsList] = useState([]);
    useEffect(() => {
        LoadData();
    }, [integrationId]);
    const LoadData = () => {
        AxiosAPI({
            method: 'get',
            url: `${gAPI_Ingetration}/${integrationId}?group_id=${getGroupID()}`,
        })
            .then((res) => {
                const modelNudges = res.data.channelDetails.initiationRuleset[0].nudges.map((nudge) => {
                    if (nudge.eyeCatcher && nudge.greeting) {
                        return {
                            eyeCatcher: {
                                code: nudge.eyeCatcher.query.code,
                                filterTags: null,
                            },
                            greeting: {
                                code: nudge.greeting.query.code,
                                filterTags: null,
                            },
                            delayInMilliseconds: nudge.delayInMilliseconds,
                            delayInMillisecondsInMobile: nudge.delayInMillisecondsInMobile,
                            disabledInDesktop: nudge.disabledInDesktop,
                            disabledInMobile: nudge.disabledInMobile,
                            buttons: nudge.buttons,
                        };
                    }
                });
                const engagementRules = res.data.engagementRules;
                const enableRuleStatus = res.data.ruleDisabled;
                setEnabled(enableRuleStatus);
                setInputData({
                    ...inputData,
                    name: res.data.name,
                    level: res.data.level,
                    properties: [...res.data.properties],
                    sessionTimeoutInSeconds: res.data.sessionTimeoutInSeconds,
                    baseUrl: res.data.channelDetails.baseUrl,
                    homePageRoute: res.data.channelDetails.homePageRoute,
                    defaultLanguage: 'en-US',
                    defaultRuleDescription: 'Default',
                    defaultRuleNudges: [...modelNudges],
                    botSettings: { ...res.data.botSettings },
                    menuEnabled: res.data.channelDetails.menuEnabled,
                    persistentMenu: res.data.channelDetails.persistentMenu,
                    liveChatSetting: res.data.liveChat,
                    engagementRules: [...engagementRules],
                    ruleDisabled: res.data.ruleDisabled
                });
                setRuleDataList(engagementRules);
                let optionData = {
                    propertyId: res.data.properties
                };
                AxiosAPI({
                    method: 'post',
                    url: `${postAPI_QuestionOption_AllList}`,
                    data: optionData
                })
                    .then((res) => {
                        if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                            && res.data.Messages !== null && res.data.Messages.length > 0) {
                            setMsg(res.data.Messages);
                            setOpen(true);
                        }
                        else {
                            var options = [];
                            try {
                                res.data.options.filter((i) => i.status === "Active").map(
                                    (item) => options.push({ value: item.id, label: item.option })
                                );
                                setQuestionOptionsList(options);
                            }

                            catch { setQuestionOptionsList(options); }
                        }

                    })
                    .catch((err) => console.log('err', err));
            })
            .catch((err) => console.log('err', err));
    };
    const handleChange = (e) => {
        const value = e.target.checked;
        setEnabled(value);
    };
    const handleSaveStatus = () => {
        var msg = enabled ? "enabled" : "disabled";
        let body = {
            ...inputData,
            ruleDisabled: enabled
        }
        AxiosAPI({
            method: 'put',
            url: `${putAPI_Update_Ingetration}/${integrationId}?group_id=${getGroupID()}`,
            data: body,
        })
            .catch((err) => console.error(err))
            .then((res) => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                }
                else {
                    NotificationManager.success(
                        "",
                        "Engagement rule  " + msg + " successfully",
                        3000,
                        null,
                        null,
                        "success"
                    );
                    setTimeout(() => {
                        LoadData();
                        LoadIntegration();
                    }, 1000);
                }
            });
        setIsStatusUpdating(!isStatusUpdating);
    };
    const editStatus = () => {
        setIsStatusUpdating(!isStatusUpdating);
        setIsUpdating(false);
    };
    const edit = () => {
        setIsStatusUpdating(false);
        setIsUpdating(!isUpdating);
    }
    const deleteRule = (data) => {
        let body = {
            ...inputData,
            engagementRules: data
        }
        AxiosAPI({
            method: 'put',
            url: `${putAPI_Update_Ingetration}/${integrationId}?group_id=${getGroupID()}`,
            data: body,
        })
            .catch((err) => console.error(err))
            .then((res) => {

                NotificationManager.success(
                    '',
                    'Engagement rule deleted successfully',
                    3000,
                    null,
                    null,
                    'success'
                );
                setTimeout(() => {
                    LoadData();
                    LoadIntegration();
                }, 1000);
            });
    };

    const handleSubmit = (data) => {
        let msg = data.id !== undefined ? "updated" : "created";
        AxiosAPI({
            method: 'put',
            url: `${putAPI_Update_EngagementRules}/${integrationId}?group_id=${getGroupID()}`,
            data: data,
        }).catch((err) => console.error(err))
            .then((res) => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                }
                else {

                    NotificationManager.success(
                        '',
                        'Engagement rule ' + msg + ' successfully',
                        3000,
                        null,
                        null,
                        'success'
                    );
                    setTimeout(() => {
                        LoadData();
                        LoadIntegration();
                    }, 1000);
                }
            });
    };
    return (
        <Fragment>
            <Card className="mb-4">
                <CardBody>
                    <h6 className="text-center">Rules</h6>
                    <Separator className="mb-3" />
                    <Fragment>
                        {isStatusUpdating ? (
                            <div className="text-center">
                                <div className="mb-1">
                                    <b>Enable</b>
                                    <br />
                                    <CustomInput
                                        id="lan"
                                        type="checkbox"
                                        checked={enabled}
                                        name="engagementRules"
                                        onChange={handleChange}
                                    />
                                </div>
                                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                                    <Button color="primary" size="xs" onClick={handleSaveStatus}>
                                        Save
                                    </Button>
                                    <Button
                                        size="xs"
                                        color="dark"
                                        outline
                                        onClick={() => {
                                            editStatus()
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </ButtonGroup>
                            </div>
                        ) : (
                            <div className="text-center">
                                {inputData && (
                                    <Fragment>
                                        <div className="mb-1">
                                            <b>Enable: </b>
                                            {inputData.ruleDisabled}
                                            {inputData.ruleDisabled ? 'Yes' : 'No'}
                                        </div>
                                        <div className='mb-1'>
                                            {ruleDataList && (
                                                <RuleList
                                                    liveChatSetting={inputData && inputData.liveChatSetting}
                                                    propertiesList={inputData && inputData.properties}
                                                    ruleDataList={ruleDataList}
                                                    integrationId={integrationId}
                                                    deleteRule={deleteRule}
                                                    submit={handleSubmit}
                                                    questionOption={questionOptionsList}
                                                ></RuleList>
                                            )}
                                        </div>
                                    </Fragment>
                                )}
                                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                                    <Button
                                        size="xs"
                                        color="success"
                                        outline
                                        onClick={() => edit()}
                                    >
                                        Add New Rule
                                    </Button>
                                    <Button
                                        size="xs"
                                        color="success"
                                        outline
                                        onClick={() => editStatus()}
                                    >
                                        Update Rule Status
                                    </Button>
                                </ButtonGroup>
                            </div>
                        )}
                        {isUpdating && (
                            <Fragment>
                                <RuleForm
                                    visible={isUpdating}
                                    formLabel={"Create"}
                                    toggle={() => {
                                        setIsUpdating(!isUpdating);
                                    }}
                                    integrationId={integrationId}
                                    submit={handleSubmit}
                                    questionOption={questionOptionsList}
                                ></RuleForm>
                            </Fragment>
                        )}
                    </Fragment>
                </CardBody>
            </Card>

            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </Fragment>
    );

};